import React from 'react';
import Container from 'react-bootstrap/Container';

export default function TextPage({ children }) {

  return (
    <Container className='text-center justify-content-center'>
      {children}
    </Container>
  );
}
